import { makeStyles } from '@material-ui/core/styles';
import { Box, IconButton, Modal } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import WarpSvg from './warp/WarpSvg';


const useStyles = makeStyles((theme) => ({
  manualWarpModal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  manualWarpContent: {
    position: 'relative',
    backgroundColor: theme.palette.background.paper,
    borderRadius: theme.shape.borderRadius,
    boxShadow: theme.shadows[5],
    padding: theme.spacing(4),
    outline: 'none',
    maxWidth: '95vw',
    maxHeight: '95vh',
    width: '90vw',
    height: '90vh',
    display: 'flex',
    flexDirection: 'column',
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
  },
}));

const ManualWarpModal = ({ open, onClose, pattern, ringPath, meshComplexity, interpolation, savedControlPoints, savedPatternPosition, savedPatternScale, savedHistory, savedHistoryIndex, onSave }) => {
  const classes = useStyles();
  return (
    <Modal open={open} onClose={onClose} className={classes.manualWarpModal}>
      <Box className={`${classes.manualWarpContent} manual-warp-js`}>
        <IconButton className={classes.closeButton} onClick={onClose}>
          <CloseIcon />
        </IconButton>
        <WarpSvg
          pattern={pattern}
          ringPath={ringPath}
          meshComplexity={meshComplexity}
          interpolation={interpolation}
          savedControlPoints={savedControlPoints}
          savedPatternPosition={savedPatternPosition}
          savedPatternScale={savedPatternScale}
          savedHistory={savedHistory}
          savedHistoryIndex={savedHistoryIndex}
          onSave={onSave}
        />
      </Box>
    </Modal>
  );
};

export default ManualWarpModal;